import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapPromotionsResponse } from "src/utils/mapPromotion";

/**
 * Fetches promotion hub cards from pg-payload-cms.
 * Filtering by publish/unpublish dates is done client-side via filterPromotionCards().
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapPromotion').PromotionCard[]>}
 */
export async function fetchPromotions(locale) {
  const url = buildPayloadApiUrl("/api/promotions", {
    locale,
    limit: 200,
    sort: "_order",
    depth: 0,
  });

  const response = await payloadFetch(url);
  return mapPromotionsResponse(response, locale);
}
